import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetComments = (postId: string, t: any, isLMS?: boolean) => {
    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {

        if (!postId) return;

        setIsLoading(true)
        const request = API.request()
            .endpoint(Endpoints.gateway)
            .url('message/api/comment/GetByEntity')
            .get()
            .addQuery('entityId', postId || '')
            .addQuery('entityType', 'post')
        
        if (isLMS) {
            request.addQuery('statuses', 0)
        }
        
        request.send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [postId, t, isLMS])

    return [API.toLang(resp, i18n.language) as any, isLoading, error];
}
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";

export const useGetComments = (postId: string, t: any, isLMS?: boolean) => {
    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {

        if (!postId) return;

        setIsLoading(true)
        const request = API.request()
            .endpoint(Endpoints.gateway)
            .url('message/api/comment/GetByEntity')
            .get()
            .addQuery('entityId', postId || '')
            .addQuery('entityType', 'post')
        
        if (isLMS) {
            request.addQuery('statuses', 0)
        }
        
        request.send()
            .then((r) => r ? r.json() : undefined)
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [postId, t, isLMS])

    return [API.toLang(resp, i18n.language) as any, isLoading, error];
}
